<div class="d-flex justify-content-center align-items-start p-4 min-vh-100">
  <div class="maintenance-content w-100 text-center p-4">
    <h2 class="m-0">Sidan är stängd för underhåll.</h2>
  </div>
</div>
